'use client';

import React from 'react';

import Link from 'next/link';

import { styles } from '.';
import { toClassName } from 'helpers/format';
import { usePathname } from 'next/navigation';
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from '@repo/ui/navigation-menu';

type TProps = {
  locale: string;
  routes: {
    id: string;
    label: string;
    url: string;
    visibility?: string;
  }[];
};

const CtaSection = (props: TProps) => {
  const { routes } = props;

  const pathname = usePathname();

  return (
    <div>
      <NavigationMenu className={styles.container}>
        <NavigationMenuList>
          {routes.map((route) => {
            if (
              route.visibility === 'HIDDEN' ||
              route.visibility === 'MENU_ONLY'
            ) {
              return;
            }

            if (route.id !== 'contact' && route.id !== 'apply') {
              return;
            }

            return (
              <NavigationMenuItem key={route.id}>
                <Link
                  href={route.url.replaceAll('*', '')}
                  target={route.url.includes('*') ? '_blank' : ''}
                  passHref
                  as={route.url.replaceAll('*', '')}
                  // className="w-full flex"
                >
                  <div
                    className={toClassName(
                      // styles.button,
                      'whitespace-nowrap hover:opacity-20',
                      pathname.includes(route.url) && '!opacity-20',
                      'uppercase',
                    )}
                  >
                    {route.label}
                  </div>
                </Link>
              </NavigationMenuItem>
            );
          })}
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
};

export default CtaSection;
